import React from 'react';

import {BeneficiaryInfo} from 'presentation/components/MainHeader/ProfileMenu/components';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {UserHealthCardContainer} from './styles';
import {BeneficiaryCardProps} from './types';
import {BeneficiaryInfoLegacy} from 'presentation/components/MainHeader/ProfileMenu/components/BeneficiaryInfo/BeneficiaryInfoLegacy';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum, SelectionFlowEnum} from 'presentation/constants';
import {useNavigate} from 'react-router-dom';
import {useProfileSectionStore} from '../../store/useProfileSection';

export function BeneficiaryCard({isResponsibleWithoutBenefits}: BeneficiaryCardProps) {
	const navigate = useNavigate();
	const setIsProfileCompleted = useProfileSectionStore(state => state.setIsProfileCompleted);

	const {
		beneficiary: {nmSocialUsuarioC},
	} = useAccountInformation();

	const {isEnabled: isNewProfileFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);

	const goToPlanSelection = () => {
		navigate(SelectionFlowEnum.PLAN_SELECTION);
		setIsProfileCompleted(false);
	};

	return (
		<UserHealthCardContainer elevation={0}>
			{isNewProfileFeatureFlagEnabled ? (
				<BeneficiaryInfo
					hasSocialNameToolTip={!nmSocialUsuarioC}
					isResponsibleWithoutBenefits={isResponsibleWithoutBenefits}
					goTo={goToPlanSelection}
				/>
			) : (
				<BeneficiaryInfoLegacy
					hasSocialNameToolTip={!nmSocialUsuarioC}
					isResponsibleWithoutBenefits={isResponsibleWithoutBenefits}
				/>
			)}
		</UserHealthCardContainer>
	);
}
